import { render, staticRenderFns } from "./doc.vue?vue&type=template&id=733fb95f&scoped=true&"
import script from "./doc.js?vue&type=script&lang=js&"
export * from "./doc.js?vue&type=script&lang=js&"
import style0 from "./doc.css?vue&type=style&index=0&id=733fb95f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "733fb95f",
  null
  
)

export default component.exports